<div class="grid-1">
    <app-card>
      <span class="text-center padding-top text-subtitle">Beste {{this.user?.name}}</span>
      <span class="text-center padding text-subtitle">Onlangs heb je contact gehad met onze klantenservice. We horen graag hoe je dit contact hebt ervaren</span>
      <span class="text-center padding text-heading">Wat vond je van het contact met de klantenservice?</span>
      <span class="text-center padding">
        <app-stars size="lg" [numStarsSelected]="this.survey?.rating ?? 0" (ratingSelected)="onRatingSelected($event)"></app-stars>
      </span>
    </app-card>
</div>
